{
    "productDashboard": {
        "common": {
            "last": "Last",
            "for": "For",
            "days": "days",
            "day": "day",
            "categories": "categories",
            "open": "Open",
            "inProgress": "In Progress",
            "inProgressShort": "In Prog.",
            "resolved": "Resolved",
            "clear": "Clear",
            "selected": "selected",
            "clearAllFilters": "Clear all filters"
        },
        "shell": {
            "dataUpdated": "Data updated",
            "latestTurn": "latest turn",
            "records": "records",
            "ofData": "of data",
            "syncing": "Syncing…",
            "refresh": "↻ Refresh data",
            "dataRefreshed": "Data refreshed.",
            "syncFailed": "Sync failed to start.",
            "syncCompletedWithErrors": "Sync completed with errors:",
            "timeRangeAria": "Time range",
            "overview": "Overview",
            "myhelpData": "from MyHelp data",
            "rangeLabel": "Range",
            "rangeAria": "Custom date range",
            "rangeFrom": "From",
            "rangeTo": "To",
            "rangeApplyAria": "Apply date range",
            "rangeClearAria": "Clear date range",
            "rangeSelectBoth": "Select both a start and end date.",
            "rangeInvalidOrder": "The start date must be before the end date.",
            "rangeTooWide": "Select a range of up to",
            "dateRangeCaption": "Date Range"
        },
        "overview": {
            "greetingMorning": "Good morning",
            "greetingAfternoon": "Good afternoon",
            "greetingEvening": "Good evening",
            "greetingNight": "Good night",
            "subtitle": "Here's what's happening across your products today.",
            "tabOverview": "Overview",
            "tabActionsForYou": "Actions for you",
            "actionsTitle": "Actions for you",
            "actionsMeta": "Recommended next steps for Product Team",
            "kpiTotalQueries": "TOTAL QUERIES",
            "kpiIncidentsRaised": "INCIDENTS RAISED (Since 10 Sept)",
            "kpiUpcoming": "UPCOMING FEATURE",
            "kpiCallback": "CALLBACK REQUESTS (Since 10 Sept)",
            "kpiLiveChat": "LIVE CHAT REQUESTS (Since 10 Sept)",
            "viewBreakdown": "Breakdown →",
            "viewAllIncidents": "All incidents →",
            "upcomingTitle": "New feature coming soon",
            "upcomingSub": "More product insights are on the way.",
            "topCategories": "Top Query Categories",
            "viewAll": "View all →",
            "tipQueries": "Queries",
            "uniqueUsersTitle": "Unique Users",
            "detailedView": "Detailed View",
            "usersPerDay": "Unique users per day",
            "usersPerWeek": "Unique users per week",
            "usersPerMonth": "Unique users per month",
            "uniqueUsersTrendTooltipLead": "Compares",
            "uniqueUsersTrendTooltipConnector": "to",
            "kpiTooltips": {
                "totalQueries": "Total queries received across all products in the selected time range.",
                "incidentsRaised": "Support incidents raised from chatbot conversations, broken down by status.",
                "upcoming": "A new dashboard feature is on the way — check back soon.",
                "callback": "Callback requests submitted by users, split by language.",
                "liveChat": "Live chat requests submitted by users, split by language.",
                "feedbackCoverage": "Share of total queries that received user feedback (👍 or 👎)."
            }
        },
        "totalQueries": {
            "title": "Total Queries Insights",
            "queries": "queries",
            "vsPrior": "vs prior period",
            "chartTitle": "Queries by Category",
            "breakdownTitle": "Category Breakdown",
            "thCategory": "CATEGORY",
            "thQueries": "QUERIES",
            "thShare": "SHARE",
            "thDistribution": "DISTRIBUTION",
            "tipQueries": "Queries",
            "tipShare": "Share %",
            "searchPlaceholder": "Search",
            "matchesSuffix": "matches",
            "matchSuffix": "match"
        },
        "incidents": {
            "title": "Problem Categories",
            "incidents": "incidents",
            "thId": "ID",
            "thIssue": "QUERY / ISSUE",
            "thCategory": "CATEGORY",
            "thProduct": "PRODUCT",
            "thCompany": "COMPANY",
            "thSeverity": "SEVERITY",
            "thStatus": "STATUS",
            "empty": "No MyHelp incidents in this period.",
            "severityHigh": "High",
            "severityMedium": "Medium",
            "severityLow": "Low",
            "incident": "incident",
            "breakdownTitle": "Category Breakdown",
            "thIncidents": "INCIDENTS",
            "thShare": "SHARE",
            "thDistribution": "DISTRIBUTION",
            "searchPlaceholder": "Search",
            "matchesSuffix": "matches",
            "matchSuffix": "match"
        },
        "incidentCategory": {
            "titlePrefix": "Incidents in",
            "loadError": "Couldn't load incidents.",
            "incident": "incident",
            "incidents": "incidents",
            "closeAria": "Close",
            "thDate": "DATE",
            "empty": "No incidents found for this category.",
            "loading": "Loading…",
            "loadMorePrefix": "Load more (showing",
            "of": "of"
        },
        "userSentiment": {
            "title": "User Feedback Insights",
            "summaryLikes": "likes",
            "summaryDislikes": "dislikes",
            "last": "Last",
            "days": "days",
            "likes": "Likes",
            "dislikes": "Dislikes",
            "chartTitle": "Likes vs Dislikes by Category",
            "detailTitle": "Category Feedback Detail",
            "positive": "Positive",
            "thingsWell": "Things that went well",
            "thingsAttention": "Things that needs attention",
            "askAiHint": "Ask the AI assistant about this (opens in a new tab)",
            "searchPlaceholder": "Search",
            "matchesSuffix": "matches",
            "matchSuffix": "match"
        },
        "products": {
            "title": "Product Categories",
            "products": "products",
            "queryVolume": "Query Volume",
            "incidents": "Incidents",
            "sentiment": "Sentiment",
            "healthScore": "Health score"
        },
        "companyFilter": {
            "allCompanies": "All Companies",
            "allCompaniesShort": "All companies",
            "selectedSuffix": "companies selected",
            "filterAria": "Filter by company",
            "searchPlaceholder": "Search companies…",
            "noMatchPrefix": "No companies match"
        },
        "clusterFilter": {
            "allClusters": "All Clusters",
            "allClustersShort": "All clusters",
            "selectedSuffix": "clusters selected",
            "filterAria": "Filter by cluster",
            "searchPlaceholder": "Search clusters…",
            "noMatchPrefix": "No clusters match"
        },
        "categoryFilter": {
            "allCategories": "All Categories",
            "selectedSuffix": "categories selected",
            "filterAria": "Filter by category",
            "searchPlaceholder": "Search categories…",
            "allCategoriesShort": "All categories",
            "selectedShort": "selected",
            "clear": "Clear",
            "noMatchPrefix": "No categories match"
        },
        "categoryQueries": {
            "like": "Like",
            "dislike": "Dislike",
            "titlePrefix": "Queries in",
            "loadError": "Couldn't load queries.",
            "query": "query",
            "queries": "queries",
            "preparing": "Preparing…",
            "downloadExcel": "⬇ Download Excel",
            "closeAria": "Close",
            "thQuery": "QUERY",
            "thSentiment": "SENTIMENT",
            "thDate": "DATE",
            "thSource": "SOURCE",
            "thLanguage": "LANGUAGE",
            "thCompany": "COMPANY",
            "colQuery": "Query",
            "colSentiment": "Sentiment",
            "colDate": "Date",
            "colSource": "Source",
            "colLanguage": "Language",
            "colCompany": "Company",
            "empty": "No queries found for this category.",
            "loading": "Loading…",
            "loadMorePrefix": "Load more (showing",
            "of": "of",
            "sortSentimentHint": "Click to sort by sentiment",
            "sortDateHint": "Click to sort by date"
        },
        "feedbackPie": {
            "likes": "Likes",
            "dislikes": "Dislikes",
            "noFeedback": "No feedback",
            "coverage": "FEEDBACK COVERAGE",
            "meta": "of total queries",
            "feedback": "feedback",
            "noData": "No data",
            "viewFeedback": "User feedback →"
        },
        "requestCard": {
            "empty": "No requests in this period.",
            "breakdown": "Breakdown →"
        },
        "requestBreakdown": {
            "titleCallback": "Callback Requests — Language Breakdown",
            "titleLiveChat": "Live Chat Requests — Language Breakdown",
            "breakdownTitle": "Language Breakdown",
            "thLanguage": "LANGUAGE",
            "thCount": "COUNT",
            "thShare": "SHARE",
            "thDistribution": "DISTRIBUTION",
            "language": "language",
            "languages": "languages",
            "request": "request",
            "requests": "requests",
            "empty": "No requests in this period."
        },
        "tabError": {
            "title": "Couldn't load dashboard data",
            "message": "The data service didn't respond. Please retry — no data is shown so nothing here is estimated."
        },
        "actionItems": {
            "knowledgeArticles": {
                "title": "Create / Update Knowledge Articles",
                "hint": "Keep your product content accurate and up to date",
                "childTitle": "Knowledge Base Creation and Update",
                "childHint": "How to create and update the knowledge base."
            },
            "scripts": {
                "title": "Build and Deploy Scripts via Nexthink Remote Actions",
                "hint": "Automate fixes the issue by enabling remote action on user device machine",
                "childTitle": "Link to order the Nexthink",
                "childHint": "Remote Action Management"
            }
        }
    }
}
